import React, { useEffect } from "react";

export default function ThankYou() {

  // 🔒 Disable Back Button
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <style>
        {`
        /* Background Gradient Animation */
        body {
          animation: gradientBg 6s infinite alternate ease-in-out;
        }
        @keyframes gradientBg {
          0% { background: linear-gradient(120deg, #bbf7d0, #fce7f3); }
          50% { background: linear-gradient(120deg, #e0f2fe, #fde68a); }
          100% { background: linear-gradient(120deg, #f3e8ff, #fecaca); }
        }

        /* Confetti floating */
        .confetti {
          position: absolute;
          width: 10px;
          height: 10px;
          background: rgba(255,255,255,0.9);
          top: -10px;
          border-radius: 50%;
          animation: fall linear infinite;
          opacity: 0.8;
        }
        @keyframes fall {
          0% { transform: translateY(-10px) rotate(0deg); }
          100% { transform: translateY(110vh) rotate(360deg); }
        }

        /* Card animation */
        @keyframes cardPop {
          0% { transform: scale(0.7) rotateX(25deg); opacity: 0; }
          100% { transform: scale(1) rotateX(0deg); opacity: 1; }
        }

        /* Glowing pulse */
        @keyframes pulseGlow {
          0% { box-shadow: 0 0 15px rgba(16,185,129,0.2); }
          50% { box-shadow: 0 0 35px rgba(16,185,129,0.45); }
          100% { box-shadow: 0 0 15px rgba(16,185,129,0.2); }
        }

        /* Shiny heading */
        @keyframes shine {
          0% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.1); }
          100% { opacity: 0.7; transform: scale(1); }
        }
      `}
      </style>

      {/* 20 Confetti Particles */}
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          className="confetti"
          style={{
            left: Math.random() * 100 + "vw",
            animationDuration: 3 + Math.random() * 5 + "s",
            backgroundColor: ["#f87171", "#60a5fa", "#34d399", "#fbbf24", "#c084fc"][i % 5],
          }}
        ></div>
      ))}

      <div
        className="thank-card"
        style={{
          background: "white",
          padding: "50px",
          borderRadius: "20px",
          textAlign: "center",
          width: "480px",
          animation: "cardPop 1s ease-out",
          boxShadow: "0 10px 35px rgba(0,0,0,0.15)",
          animationIterationCount: "1",
          animationFillMode: "forwards",
          animationTimingFunction: "ease-out",
          animationName: "cardPop",
          position: "relative",
          zIndex: 2,
        }}
      >
        <h1
          style={{
            marginBottom: "15px",
            color: "#16a34a",
            animation: "shine 2s infinite ease-in-out",
            fontSize: "40px",
          }}
        >
          🎉 Thank You!
        </h1>

        <p style={{ fontSize: "20px", marginBottom: "20px", opacity: 0.9 }}>
          Your exam has been submitted successfully.
        </p>

        <p style={{ fontSize: "18px", color: "#374151", opacity: 0.8 }}>
          Result will be notified to you separately on your email.
        </p>
      </div>
    </div>
  );
}
